export default __webpack_public_path__ + "static/media/icon-other-gray.8b22219c.svg";